// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1ulK6","box":"WorkspacesBox_box__2Fqo4","node":"WorkspacesBox_node__IpZ3G"};